var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigbusiness6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6801)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 119.593,
    x2: 17.9658,
    y2: -21.9222,
    stroke: "url(#paint0_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 119.593,
    x2: 52.9658,
    y2: -21.9222,
    stroke: "url(#paint1_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 119.593,
    x2: 88.9658,
    y2: -21.9222,
    stroke: "url(#paint2_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 119.593,
    x2: 124.966,
    y2: -21.9222,
    stroke: "url(#paint3_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 119.593,
    x2: 160.966,
    y2: -21.9222,
    stroke: "url(#paint4_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 119.593,
    x2: 195.966,
    y2: -21.9222,
    stroke: "url(#paint5_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 119.593,
    x2: 231.966,
    y2: -21.9223,
    stroke: "url(#paint6_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.4539,
    x2: 258.387,
    y2: 18.4538,
    stroke: "url(#paint7_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.4539,
    x2: 258.387,
    y2: 77.4538,
    stroke: "url(#paint8_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.4539,
    x2: 258.387,
    y2: 47.4538,
    stroke: "url(#paint9_linear_75_6801)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 103,
    height: 103,
    rx: 49.5,
    fill: "url(#paint10_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4062 52.375C62.536 52.375 61.7014 52.7207 61.0861 53.3361C60.4707 53.9514 60.125 54.786 60.125 55.6563C60.125 56.5265 60.4707 57.3611 61.0861 57.9764C61.7014 58.5918 62.536 58.9375 63.4062 58.9375H66.6875V66.8125H52.9062C52.036 66.8125 51.2014 66.4668 50.5861 65.8514C49.9707 65.2361 49.625 64.4015 49.625 63.5313V62.2188C49.625 60.4058 51.095 58.9375 52.9062 58.9375H58.494C57.6432 57.6736 57.3137 56.1297 57.5744 54.6286C57.8352 53.1274 58.6659 51.7851 59.8931 50.8821C61.1203 49.9791 62.649 49.5853 64.1597 49.783C65.6705 49.9806 67.0464 50.7544 68 51.9428C68.9536 50.7544 70.3295 49.9806 71.8403 49.783C73.351 49.5853 74.8797 49.9791 76.1069 50.8821C77.3341 51.7851 78.1648 53.1274 78.4256 54.6286C78.6863 56.1297 78.3568 57.6736 77.506 58.9375H84.4062C86.2175 58.9375 87.6875 60.4075 87.6875 62.2188V63.5313C87.6875 65.3443 86.2175 66.8125 84.4062 66.8125H69.3125V58.9375H72.5938C73.2427 58.9375 73.8771 58.7451 74.4167 58.3845C74.9563 58.024 75.3769 57.5115 75.6252 56.9119C75.8736 56.3124 75.9386 55.6526 75.812 55.0161C75.6853 54.3796 75.3728 53.795 74.9139 53.3361C74.4551 52.8772 73.8704 52.5647 73.2339 52.4381C72.5974 52.3114 71.9376 52.3764 71.3381 52.6248C70.7385 52.8731 70.226 53.2937 69.8655 53.8333C69.5049 54.3729 69.3125 55.0073 69.3125 55.6563V58.9375H66.6875V55.6563C66.6875 53.8433 65.2175 52.375 63.4062 52.375ZM66.6875 69.4375H52.25V81.25C52.25 82.2943 52.6648 83.2958 53.4033 84.0342C54.1417 84.7727 55.1432 85.1875 56.1875 85.1875H66.6875V69.4375ZM69.3125 69.4375V85.1875H81.125C82.1693 85.1875 83.1708 84.7727 83.9092 84.0342C84.6477 83.2958 85.0625 82.2943 85.0625 81.25V69.4375H69.3125Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 103,
    height: 103,
    rx: 49.5,
    stroke: "url(#paint11_linear_75_6801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.527 185.125V170.169H17.1161V185.125H19.527ZM24.1704 185.125V179.634C24.1704 177.223 25.2642 175.973 27.6974 175.973C29.9967 175.973 30.9342 177.022 30.9342 179.098V185.125H33.3451V178.45C33.3451 175.883 31.8271 173.807 28.7466 173.807C25.9339 173.807 24.4606 175.593 24.1257 177.468H23.9695V174.03H21.7595V185.125H24.1704ZM41.0964 185.348C44.4225 185.348 46.8557 183.473 46.8557 180.705V180.46H44.4672V180.616C44.4672 182.335 43.2171 183.183 41.0518 183.183C38.5516 183.183 37.4354 181.977 37.4354 179.589C37.4354 177.156 38.5516 175.973 41.0518 175.973C43.2171 175.973 44.4672 176.821 44.4672 178.54V178.674H46.8557V178.45C46.8557 175.682 44.4225 173.807 41.0964 173.807C37.4354 173.807 35.0469 176.129 35.0469 179.589C35.0469 183.004 37.4354 185.348 41.0964 185.348ZM54.2193 185.348C57.5231 185.348 59.8447 183.719 59.8447 181.352V181.152H57.4338V181.33C57.4338 182.647 56.4739 183.406 54.1524 183.406C51.5852 183.406 50.536 182.268 50.4467 180.125H59.867C59.934 179.79 59.9563 179.477 59.9563 179.075C59.9563 175.705 57.6124 173.807 54.1747 173.807C50.5584 173.807 48.1921 176.129 48.1921 179.589C48.1921 183.295 50.5807 185.348 54.2193 185.348ZM54.13 175.705C56.4963 175.705 57.6794 176.687 57.6794 178.741V178.785H50.4691C50.603 176.799 51.6745 175.705 54.13 175.705ZM64.1729 185.125V179.634C64.1729 177.223 65.2667 175.973 67.6999 175.973C69.9992 175.973 70.9368 177.022 70.9368 179.098V185.125H73.3476V178.45C73.3476 175.883 71.8297 173.807 68.7491 173.807C65.9364 173.807 64.4631 175.593 64.1283 177.468H63.972V174.03H61.762V185.125H64.1729ZM82.7732 185.125V182.96H80.7641C79.3801 182.96 78.755 182.603 78.755 181.241V176.04H82.7732V174.03H78.755V171.597H76.3665V174.03H74.4914V176.04H76.3665V181.375C76.3665 184.076 77.8398 185.125 80.2284 185.125H82.7732ZM86.6921 172.736V170.169H84.2812V172.736H86.6921ZM86.6921 185.125V174.03H84.2812V185.125H86.6921ZM96.0455 185.125L101.269 174.03H98.6573L94.7062 182.781H94.5276L90.5764 174.03H87.92L93.0989 185.125H96.0455ZM108.087 185.348C111.39 185.348 113.712 183.719 113.712 181.352V181.152H111.301V181.33C111.301 182.647 110.341 183.406 108.02 183.406C105.452 183.406 104.403 182.268 104.314 180.125H113.734C113.801 179.79 113.824 179.477 113.824 179.075C113.824 175.705 111.48 173.807 108.042 173.807C104.426 173.807 102.059 176.129 102.059 179.589C102.059 183.295 104.448 185.348 108.087 185.348ZM107.997 175.705C110.363 175.705 111.547 176.687 111.547 178.741V178.785H104.336C104.47 176.799 105.542 175.705 107.997 175.705ZM120.875 185.348C124 185.348 126.054 184.12 126.054 182.044C126.054 180.214 124.849 179.321 122.214 178.986L119.647 178.629C117.973 178.406 117.527 178.093 117.527 177.223C117.527 176.173 118.241 175.727 120.272 175.727C122.728 175.727 123.398 176.419 123.398 177.736V177.87H125.786V177.803C125.786 175.169 123.732 173.807 120.339 173.807C116.924 173.807 115.16 175.191 115.16 177.133C115.16 178.986 116.433 179.879 118.531 180.147L121.567 180.549C123.152 180.772 123.688 181.062 123.688 181.977C123.688 182.96 123.04 183.406 120.875 183.406C118.554 183.406 117.683 182.937 117.683 181.486V181.308H115.272V181.375C115.272 183.942 117.303 185.348 120.875 185.348ZM134.868 185.348C137.39 185.348 139.154 184.232 139.734 182.357H139.89V185.125H142.1V178.383C142.1 175.727 140.515 173.807 136.988 173.807C133.461 173.807 131.363 175.705 131.363 178.227V178.317H133.751V178.227C133.751 176.598 134.756 175.928 136.81 175.928C138.93 175.928 139.734 176.575 139.734 178.406V179.053L134.689 179.589C132.501 179.834 131.117 180.727 131.117 182.446C131.117 184.277 132.568 185.348 134.868 185.348ZM133.528 182.29C133.528 181.419 134.131 181.129 135.381 180.973L139.734 180.482C139.734 182.669 138.037 183.607 135.515 183.607C134.131 183.607 133.528 183.183 133.528 182.29ZM146.663 185.125V179.634C146.663 177.223 147.757 175.973 150.19 175.973C152.489 175.973 153.427 177.022 153.427 179.098V185.125H155.838V178.45C155.838 175.883 154.32 173.807 151.239 173.807C148.427 173.807 146.953 175.593 146.619 177.468H146.462V174.03H144.252V185.125H146.663ZM162.875 185.348C165.375 185.348 167.005 184.143 167.473 181.933H167.63V185.125H169.84V170.169H167.429V177.044H167.295C166.848 175.169 165.353 173.807 162.719 173.807C159.348 173.807 157.428 176.129 157.428 179.589C157.428 183.004 159.37 185.348 162.875 185.348ZM159.861 179.589C159.861 176.91 161.245 175.995 163.567 175.995C166.045 175.995 167.429 177.156 167.429 179.522V179.701C167.429 182.022 165.978 183.138 163.612 183.138C161.223 183.138 159.861 182.245 159.861 179.589ZM19.3261 212.125V208.933H19.4824C19.9512 211.143 21.5807 212.348 24.1032 212.348C27.6303 212.348 29.5277 210.004 29.5277 206.589C29.5277 203.129 27.6526 200.807 24.2372 200.807C21.5807 200.807 20.1074 202.169 19.661 204.044H19.527V197.169H17.1161V212.125H19.3261ZM19.527 206.701V206.522C19.527 204.156 20.8887 202.995 23.3889 202.995C25.7551 202.995 27.1168 203.91 27.1168 206.589C27.1168 209.245 25.7775 210.138 23.3442 210.138C20.9557 210.138 19.527 209.022 19.527 206.701ZM36.8688 212.348C40.5744 212.348 43.0523 210.004 43.0523 206.589C43.0523 203.129 40.5744 200.807 36.8688 200.807C33.1855 200.807 30.7077 203.129 30.7077 206.589C30.7077 210.004 33.1855 212.348 36.8688 212.348ZM36.8688 210.205C34.1901 210.205 33.0739 208.933 33.0739 206.589C33.0739 204.223 34.1901 202.928 36.8688 202.928C39.5699 202.928 40.686 204.223 40.686 206.589C40.686 208.933 39.5699 210.205 36.8688 210.205ZM47.2127 212.125V206.634C47.2127 204.223 48.3065 202.973 50.7397 202.973C53.039 202.973 53.9766 204.022 53.9766 206.098V212.125H56.3874V205.45C56.3874 202.883 54.8695 200.807 51.7889 200.807C48.9762 200.807 47.5029 202.593 47.1681 204.468H47.0118V201.03H44.8018V212.125H47.2127ZM63.1565 212.348C66.0139 212.348 67.4872 210.562 67.8443 208.687H67.9783V212.125H70.1883V201.03H67.7997V206.522C67.7997 208.933 66.6612 210.183 64.2057 210.183C61.8618 210.183 60.9019 209.134 60.9019 207.058V201.03H58.5134V207.705C58.5134 210.272 60.0313 212.348 63.1565 212.348ZM77.6244 212.348C80.7496 212.348 82.8033 211.12 82.8033 209.044C82.8033 207.214 81.5979 206.321 78.9638 205.986L76.3966 205.629C74.7224 205.406 74.276 205.093 74.276 204.223C74.276 203.173 74.9903 202.727 77.0217 202.727C79.4772 202.727 80.1469 203.419 80.1469 204.736V204.87H82.5355V204.803C82.5355 202.169 80.4817 200.807 77.0887 200.807C73.6732 200.807 71.9097 202.191 71.9097 204.133C71.9097 205.986 73.1821 206.879 75.2805 207.147L78.3164 207.549C79.9014 207.772 80.4371 208.062 80.4371 208.977C80.4371 209.96 79.7897 210.406 77.6244 210.406C75.3028 210.406 74.4322 209.937 74.4322 208.486V208.308H72.0214V208.375C72.0214 210.942 74.0527 212.348 77.6244 212.348ZM90.1235 212.348C93.4273 212.348 95.7489 210.719 95.7489 208.352V208.152H93.338V208.33C93.338 209.647 92.3781 210.406 90.0566 210.406C87.4894 210.406 86.4402 209.268 86.3509 207.125H95.7712C95.8382 206.79 95.8605 206.477 95.8605 206.075C95.8605 202.705 93.5166 200.807 90.0789 200.807C86.4626 200.807 84.0963 203.129 84.0963 206.589C84.0963 210.295 86.4849 212.348 90.1235 212.348ZM90.0342 202.705C92.4005 202.705 93.5836 203.687 93.5836 205.741V205.785H86.3733C86.5072 203.799 87.5787 202.705 90.0342 202.705ZM102.912 212.348C106.037 212.348 108.091 211.12 108.091 209.044C108.091 207.214 106.886 206.321 104.252 205.986L101.684 205.629C100.01 205.406 99.5637 205.093 99.5637 204.223C99.5637 203.173 100.278 202.727 102.309 202.727C104.765 202.727 105.435 203.419 105.435 204.736V204.87H107.823V204.803C107.823 202.169 105.769 200.807 102.376 200.807C98.961 200.807 97.1975 202.191 97.1975 204.133C97.1975 205.986 98.4699 206.879 100.568 207.147L103.604 207.549C105.189 207.772 105.725 208.062 105.725 208.977C105.725 209.96 105.077 210.406 102.912 210.406C100.591 210.406 99.7199 209.937 99.7199 208.486V208.308H97.3091V208.375C97.3091 210.942 99.3405 212.348 102.912 212.348ZM112.42 212.125V208.665H109.384V212.125H112.42Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6801",
    x1: 19.4661,
    y1: 182.688,
    x2: 19.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6801",
    x1: 54.4661,
    y1: 182.688,
    x2: 54.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6801",
    x1: 90.4661,
    y1: 182.688,
    x2: 90.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6801",
    x1: 126.466,
    y1: 182.688,
    x2: 126.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6801",
    x1: 162.466,
    y1: 182.688,
    x2: 162.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6801",
    x1: 197.466,
    y1: 182.688,
    x2: 197.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6801",
    x1: 233.466,
    y1: 182.688,
    x2: 233.466,
    y2: 48.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6801",
    x1: 269.17,
    y1: 18.9539,
    x2: -9.24119,
    y2: 18.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6801",
    x1: 269.17,
    y1: 77.9539,
    x2: -9.24119,
    y2: 77.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6801",
    x1: 269.17,
    y1: 47.9539,
    x2: -9.24119,
    y2: 47.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6801",
    x1: 68,
    y1: 16.125,
    x2: 71.1437,
    y2: 155.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508459,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6801",
    x1: 68,
    y1: 16.125,
    x2: 68,
    y2: 120.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6801"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbusiness6);
export default __webpack_public_path__ + "static/media/bigbusiness6.57ca456a4ea2c7b4d6c4b0411b0ff859.svg";
export { ForwardRef as ReactComponent };